if (!customElements.get('variant-selects')) {
  customElements.define(
    'variant-selects',
    class VariantSelects extends HTMLElement {
      constructor() {
        super();
      }

      get selectedOptionValues() {
        return Array.from(this.querySelectorAll('select option[selected], fieldset input:checked')).map(
          ({ dataset }) => dataset.optionValueId
        );
      }

      getInputForEventTarget(target) {
        return target.tagName === 'SELECT' ? target.selectedOptions[0] : target;
      }

      connectedCallback() {
        // NOVITÀ: Recuperiamo i dati completi delle varianti dal server Shopify al caricamento della pagina
        const productUrl = this.dataset.url.split('?')[0] + '.js';
        fetch(productUrl)
          .then(response => response.json())
          .then(data => {
            this.variantData = data.variants;
            this.updateAvailableOptions(); // Imposta gli sbarramenti al primo caricamento
          });

        this.addEventListener('change', (event) => {
          const target = this.getInputForEventTarget(event.target);
          this.updateSelectedSwatchValue(event);

          // NOVITÀ: Aggiorniamo le disponibilità incrociate ogni volta che l'utente clicca un'opzione
          this.updateAvailableOptions();

          FoxTheme.pubsub.publish(FoxTheme.pubsub.PUB_SUB_EVENTS.optionValueSelectionChange, {
            data: {
              event,
              target,
              selectedOptionValues: this.selectedOptionValues,
            },
          });
        });
      }

      // NUOVO METODO: Gestisce la logica di barrare/sbarrare taglie e colori
      updateAvailableOptions() {
        if (!this.variantData) return;

        const fieldsets = Array.from(this.querySelectorAll('fieldset'));

        // 1. Legge quali opzioni (Taglia, Colore) sono attualmente cliccate
        const selectedOptions = fieldsets.map((fieldset) => {
          const checkedInput = fieldset.querySelector('input:checked');
          return checkedInput ? checkedInput.value : null;
        });

        // 2. Passa in rassegna tutti i pulsanti presenti
        fieldsets.forEach((fieldset, index) => {
          const inputs = Array.from(fieldset.querySelectorAll('input[type="radio"]'));

          inputs.forEach((input) => {
            // Simula una combinazione: tiene fissa la scelta dell'altra riga e testa questa
            const hypotheticalOptions = [...selectedOptions];
            hypotheticalOptions[index] = input.value;

            // Cerca nel JSON se esiste una variante con questa precisa combinazione
            const matchingVariant = this.variantData.find((variant) => {
              return hypotheticalOptions.every((opt, i) => opt === null || variant[`option${i + 1}`] === opt);
            });

            const isAvailable = matchingVariant && matchingVariant.available;

            // Il tema Sleek sbarra i pulsanti assegnando la classe "disabled" all'input radio
            if (!isAvailable) {
              input.classList.add('disabled');
            } else {
              input.classList.remove('disabled');
            }
          });
        });
      }

      updateSelectedSwatchValue({ target }) {
        const { value, tagName } = target;

        if (tagName === 'SELECT' && target.selectedOptions.length) {
          Array.from(target.options)
            .find((option) => option.getAttribute('selected'))
            .removeAttribute('selected');
          target.selectedOptions[0].setAttribute('selected', 'selected');

          const swatchValue = target.selectedOptions[0].dataset.optionSwatchValue;
          const selectedDropdownSwatchValue = target
            .closest('.product-form__input')
            .querySelector('[data-selected-value] > .swatch');
          if (!selectedDropdownSwatchValue) return;
          if (swatchValue) {
            selectedDropdownSwatchValue.style.setProperty('--swatch--background', swatchValue);
            selectedDropdownSwatchValue.classList.remove('swatch--unavailable');
          } else {
            selectedDropdownSwatchValue.style.setProperty('--swatch--background', 'unset');
            selectedDropdownSwatchValue.classList.add('swatch--unavailable');
          }

          selectedDropdownSwatchValue.style.setProperty(
            '--swatch-focal-point',
            target.selectedOptions[0].dataset.optionSwatchFocalPoint || 'unset'
          );
        } else if (tagName === 'INPUT' && target.type === 'radio') {
          const selectedSwatchValue = target.closest(`.product-form__input`).querySelector('[data-selected-value]');
          if (selectedSwatchValue) selectedSwatchValue.innerHTML = value;
        }
      }
    }
  );
}